/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Await_Stock_Check_ShortInputs */

const vi_await_stock_check_short = /** @type {(inputs: Await_Stock_Check_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn ${i?.count} sản phẩm chưa đủ.`)
};

/**

* @param {Await_Stock_Check_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_stock_check_short = /** @type {((inputs: Await_Stock_Check_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Stock_Check_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_stock_check_short(inputs)
});